import { useState, useEffect, useRef } from "react";

// Zdrzanie pri pisani do hladania.
//
// Bez neho islo na server jeden dopyt na kazde stlacenie klavesy. Pri
// zoznamoch s tisickami zaznamov to znamenalo, ze kym clovek dopisal slovo,
// bezalo naraz pat aj viac dopytov, posledny prisiel ako prvy a zoznam
// poskakoval alebo sa zasekol. Teraz sa caka, kym clovek na chvilu prestane
// pisat, a odosle sa jediny dopyt.
//
// Zamerne ziadna podmienka na minimalny pocet znakov: jedna dvojka musi
// najst vsetky zaznamy, ktore dvojku obsahuju.
// Nazov musi zacinat na "use", je to podmienka Reactu pre hooky.
export const useZdrzanie = (hodnota, milisekundy = 300) => {
  const [zdrzana, setZdrzana] = useState(hodnota);

  useEffect(() => {
    const cas = setTimeout(() => setZdrzana(hodnota), milisekundy);
    return () => clearTimeout(cas);
  }, [hodnota, milisekundy]);

  return zdrzana;
};


// Spusti akciu az vtedy, ked sa hodnota naozaj zmeni, nie pri prvom
// vykresleni. Bez toho by sa strana nacitana z adresy (?strana=3) hned po
// otvoreni zoznamu zhodila spat na jednotku a clovek by skoncil na zaciatku.
export const usePoZmene = (hodnota, akcia) => {
  const predosla = useRef(hodnota);

  useEffect(() => {
    if (predosla.current === hodnota) {
      return;
    }
    predosla.current = hodnota;
    akcia();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hodnota]);
};

export default useZdrzanie;
